import {schema} from 'normalizr';
import schemaCollector from "../../collector/schema";

export default new schema.Entity('filtersCollector', {
  collector: schemaCollector,
});